"use client";

import React, { useEffect, useRef, useState } from "react";
import { ArrowRight, BookOpen } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ExploreDeepWaters() {
  const [mousePos, setMousePos] = useState({
    x: 0,
    y: 0
  });
  const sectionRef = useRef<HTMLElement>(null);
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (!sectionRef.current) return;
      const {
        clientX,
        clientY
      } = e;
      const {
        innerWidth,
        innerHeight
      } = window;
      const x = (clientX / innerWidth - 0.5) * 40;
      const y = (clientY / innerHeight - 0.5) * 40;
      setMousePos({
        x,
        y
      });
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);
  return <section data-section-id="224660" id="the-nova-standard" ref={sectionRef} className="relative w-full min-h-[90vh] flex items-center justify-center overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-[-5%] w-[110%] h-[110%] bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648747/img/global_logistics_hub_aerial.png)] transition-transform duration-300 ease-out will-change-transform" style={{
      transform: `translate(${mousePos.x}px, ${mousePos.y}px) scale(1.02)`
    }} />
      
      {}
      <div className="absolute inset-0 bg-black/60 bg-gradient-to-t from-black/90 via-black/40 to-transparent" />

      {}
      <div ref={contentRef} className={`relative z-10 flex flex-col items-center text-center px-6 w-full max-w-4xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <h1 className="font-default text-5xl md:text-7xl lg:text-8xl text-white mb-6 tracking-tighter drop-shadow-2xl font-bold leading-tight uppercase">
          GLOBAL PRECISION. SEAMLESS EXECUTION.
        </h1>
        
        <p className="font-default text-lg md:text-xl text-slate-300 max-w-[600px] mb-10 drop-shadow-md leading-relaxed">
          Nova Project Management supports businesses worldwide with comprehensive administration, logistics, and tailored project coordination for large-scale operations.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
          <Button asChild size="lg" className="bg-[var(--chart-1)] hover:bg-[var(--chart-1)]/90 text-white border-none rounded-sm px-8 h-14 text-base shadow-lg shadow-[var(--chart-1)]/20 transition-all duration-300">
            <Link to="/our-expertise">
              Our Expertise
              <ArrowRight className="ml-2 size-5" />
            </Link>
          </Button>
          
          <Button asChild size="lg" variant="outline" className="bg-transparent border-white/40 text-white hover:bg-white/10 hover:text-white rounded-sm px-8 h-14 text-base backdrop-blur-md transition-all duration-300">
            <Link to="/global-operations">
              <BookOpen className="mr-2 size-5" />
              View Global Projects
            </Link>
          </Button>
        </div>
      </div>

      {}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2">
        <div className="w-[1px] h-12 bg-gradient-to-b from-transparent via-[var(--chart-1)] to-transparent animate-pulse" />
      </div>
    </section>;
}